module.exports = __webpack_public_path__ + "media/CN_002.770e42ac.mp3";